import React, { useState } from "react";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  Text,
  TouchableNativeFeedback,
} from "react-native";
import Image from "@components/common/Image";
import { shareOnWhatsapp } from "../../utils/shareEntity";
import { normalize } from "../ProductDisplayUnit/metrics";
import WhatsappDefault from "../../assets/svg/WhatsappDefault";
import AppText from "../AppText";
import ZoomImageShare from "./ZoomImageShare";
import {
  OTHER_EVENTS,
  SHARING_EVENTS,
} from "../../constants/analyticsEventsCT";
import analytics from "@services/analytics";

export const WaBannerListShare = ({
  template,
  image,
  sharingLink,
  title_ref,
}) => {
  const handleShare = () => {
    analytics.trackEvent(SHARING_EVENTS.LIST_SHARE, {
      cl_title: title_ref,
      source: "thumbnail",
    });
    shareOnWhatsapp({ message: `${template}\n${sharingLink}`, image });
  };

  return (
    <TouchableNativeFeedback onPress={handleShare}>
      <View
        style={{
          backgroundColor: "#23CF5F",
          justifyContent: "center",
          alignItems: "center",
          flex: 1,
          borderRadius: 10,
        }}
      >
        <View style={[styles.wrapper, {}]}>
          <View
            style={{
              paddingRight: 6,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <WhatsappDefault size={28} />
          </View>
          <View>
            <AppText style={{ color: "#fff", fontSize: normalize(20) }} bold>
              शेयर करें
            </AppText>
          </View>
        </View>
      </View>
    </TouchableNativeFeedback>
  );
};

const ListShareItem = (props) => {
  const [showBanner, setShowBanner] = useState(false);

  const {
    title_ref,
    cms_item_id = "",
    flatBanner = false,
    image_link = "",
    link = "",
    link_type = "",
    sharingTemplate: { image_link: sharing_image_link = "", template = "" },
    sharingLink = "",
    video_link = "",
    sub_type = "",
    image_dimension_width = 1,
    image_dimension_height = 1,
    from_banner_list = false,
    fromBannerCarousel = false,
    text_ctx_cx = "",
    text_ctx_cl = "",
    trackEvent = () => {},
    fromVideoTraining = false,
    overlay_template_name = "",
    transparent_url = "",
    cl_title = "",
    cl_subtitle = "",
    listTitle = "",
  } = props;

  const handleToggleBanner = () => {
    analytics.trackEvent(OTHER_EVENTS.LIST_THUMBNIL_CLICKED, {
      cms_item_id,
      cms_list_title: listTitle,
    });
    setShowBanner(!showBanner);
  };

  return (
    <>
      <ZoomImageShare
        handleShare={() => {
          analytics.trackEvent(SHARING_EVENTS.LIST_SHARE, {
            cl_title: listTitle,
            source: "thumbnail",
          });
          shareOnWhatsapp({
            message: `${template}\n${sharingLink}`,
            image: sharing_image_link,
          });
        }}
        toggleBanner={handleToggleBanner}
        imageUrl={sharing_image_link}
        visible={showBanner}
      />
      <View style={styles.container}>
        <View
          style={{
            flex: 1,
          }}
        >
          <TouchableOpacity onPress={handleToggleBanner}>
            <Image
              resizeMode={Image.resizeMode.stretch}
              source={{
                uri: sharing_image_link,
              }}
              style={{
                width: 112,
                height: 146,
              }}
              width={112}
              height={146}
            />
          </TouchableOpacity>
        </View>
        <View
          style={{
            flex: 2,
            paddingHorizontal: 15,
            paddingVertical: 10,
          }}
        >
          <View style={{ flex: 1 }}>
            <Text style={styles.textHeader}>{cl_title}</Text>
            <Text style={styles.textSubHeader}>{cl_subtitle}</Text>
          </View>
          <View>
            <WaBannerListShare
              title_ref={listTitle}
              template={template}
              sharingLink={sharingLink}
              image={sharing_image_link}
            />
          </View>
        </View>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#efefef",
    flexDirection: "row",
    elevation: 2,
    overflow: "hidden",
    borderRadius: 6,
    marginHorizontal: normalize(15),
    marginVertical: normalize(10),
  },
  textHeader: {
    fontSize: normalize(20),
    lineHeight: normalize(24),
    fontWeight: "bold",
    color: "#000",
    marginBottom: normalize(5),
  },
  textSubHeader: {
    fontSize: normalize(14),
    lineHeight: normalize(18),
    color: "rgba(0, 0, 0, 0.56)",
    marginBottom: normalize(5),
  },
  wrapper: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: normalize(8),
  },
});

export default ListShareItem;
